module.exports = "table {\n    margin: 0;\n}\n\ntable.groupped td,\ntable.groupped th {\n    padding: 5px 2px 0 2px;\n    border: 0;\n}\n\ntd.groupped {\n    padding: 0;\n}\n\n.var-details {\n    cursor:pointer;\n    font-size: 1.2em;\n    padding-top: 20px;\n    font-weight: bold;\n}\n\n.detailed-row {\n    padding-left: 65px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/variants/variants.component.css
// module id = ./src/app/pages/variants/variants.component.css
// module chunks = main